import { getLoadStatesForCalendars as getLoadStatesForCalendarsFunction } from 'owa-calendar-events-loader';
import { hasInvalidConnectedAccount } from 'owa-accounts-store';
import { FailureType } from 'owa-calendar-load-error-message';
import type { EventsCacheLockId } from 'owa-calendar-events-store';

/**
 * Get the overall failure state. We only want to show the user one error state related the calendar load failure. So, if there are multiple failures
 * we pick the most conservative option. If anything is throttled, we want to show a throttled state so the user will not continue to make requests.
 * If they have a failed calendars, and a failed account loading, the overall failure state is just 'Failed' because this encompasses both types of failures.
 */
export default function getFailureState(cacheId: EventsCacheLockId): FailureType | null {
    if (hasAnyThrottledCalendarRequests(cacheId)) {
        return FailureType.Throttled;
    } else if (hasAnyFailedCalendarRequests(cacheId)) {
        return FailureType.Failed;
    } else if (hasInvalidConnectedAccount()) {
        return FailureType.FailedAccount;
    } else {
        return null;
    }
}

function getLoadStatesForCalendars(cacheId: EventsCacheLockId) {
    return getLoadStatesForCalendarsFunction(cacheId);
}

function hasAnyFailedCalendarRequests(cacheId: EventsCacheLockId) {
    return getLoadStatesForCalendars(cacheId).some(loadState => loadState === 'Failed');
}

function hasAnyThrottledCalendarRequests(cacheId: EventsCacheLockId) {
    return getLoadStatesForCalendars(cacheId).some(loadState => loadState === 'Throttled');
}
